import { useCallback, useState } from 'react'

import { useCustomerProductTourStatus } from 'hooks/useCustomerProductTourStatus'
import { useGoToAddCardStage } from 'hooks/useGoToAddCardStage/useGoToAddCardStage'
import {
  AddCardStage,
  CardTypeOption,
} from 'hooks/useGoToAddCardStage/useGoToAddCardStage.types'
import { ROOT } from 'const/routes'

export const useCorporateCardStartupModal = () => {
  const { showCorporateCardsAdminWelcome, updateProductTourStatus } =
    useCustomerProductTourStatus()
  const [isOpen, setIsOpen] = useState(showCorporateCardsAdminWelcome)
  const handleClose = useCallback(() => {
    updateProductTourStatus({ showCorporateCardsAdminWelcome: false })
    setIsOpen(false)
  }, [setIsOpen, updateProductTourStatus])

  const { goToAddCardStage } = useGoToAddCardStage()

  const handleCreateCard = useCallback(async () => {
    updateProductTourStatus({ showCorporateCardsAdminWelcome: false })
    setIsOpen(false)
    goToAddCardStage(
      {
        stage: AddCardStage.CreateSelectCardTypeStage,
        cardType: CardTypeOption.ExpenseCard,
      },
      ROOT.PORTAL.CARDS.CORPORATE.path
    )
  }, [goToAddCardStage, setIsOpen, updateProductTourStatus])

  return { isOpen, handleClose, handleCreateCard }
}
